<template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <v-card v-if="dialog">
        <v-card-title class="headline">{{getTables}}</v-card-title>

        <v-card-text>{{fullName}}</v-card-text>
          <v-col class="text-center" cols="12" sm="12">
            <div class="my-2" v-for="status in statuses" :key="status.id">
              <v-btn  @click="saveStatus(status.id)" block small :color="status.color">{{status.name}}</v-btn>
            </div>
          </v-col>
      </v-card>
    </v-dialog>
</template>

<script>
  const API_URL_SAVE_STATUS = 'reservation/:restaurantId/:reservationId/set-status';

  export default {
    name: "SetStatus",
    mounted() {
      bus.$on('needChangeStatus', (payload) => {
        this.reservation = payload;
        this.dialog = true;
        axios.get('list-status')
          .then(({data}) => {
            this.statuses = data.data.filter((item) => this.reservation.availabeStatus.indexOf(item.status) !== -1)
          })
      })

    },
    data() {
      return {
        savingStatus:false,
        statuses : [],
        reservation : null,
        dialog: false
      }
    },
    methods:{
      saveStatus(id) {
        if (this.savingStatus) {
          return
        }
        this.savingStatus = true;

        let data = {
          status: id,
          comment: 'Измнил статус',
          sendSms: false
        };

        let url = API_URL_SAVE_STATUS
          .replace(':restaurantId', this.reservation.restaurant_id)
          .replace(':reservationId', this.reservation.id);

        axios.post(url, data)
          .then((data) => {
            this.loadReservation()
            this.dialog = false;
          })
          .catch(e => {
            this.dialog = false;
          })
        this.savingStatus = false;
      },
    },
    computed:{
      fullName(){
        return this.reservation.guest.first_name + ' '+  this.reservation.guest.last_name;
      },
      getTables(){
        return _.map(this.reservation.tables, (table) => {
          return table.table.number
        }).join(',');
      }
    }
  }
</script>

<style scoped>

</style>
